import {Action, Props as ActionItem} from "@client/components/Action";
import * as hardware from "@client/hardware";
import * as router from "@client/router";
import {AsyncButton, SimpleIcon} from "@client/shared/typography";
import {classNames} from "@reactivated";
import * as React from "react";

const ActionBar_class = "actionBar flex";

export const BASE_ACTION_BAR_BUTTON_CLASS =
    "rounded-md text-sm font-inter font-normal px-3.5 py-2 active:text-white active:bg-indigo-700 disabled:opacity-50";

export const ACTION_BAR_BUTTON_CLASS = classNames(
    BASE_ACTION_BAR_BUTTON_CLASS,
    "bg-indigo-100 text-indigo-800",
);

interface Props {
    actionsStyle?: "legacy" | "contrast";
    actions: (ActionItem | null)[];
}

export const ActionBar = (props: Props) => {
    if (props.actions.length == 0) {
        return null;
    }

    if (props.actionsStyle == "contrast") {
        return (
            <ul className="flex justify-center gap-2">
                {props.actions
                    .filter((action) => action != null)
                    .map((action, index) => {
                        return (
                            <AsyncButton
                                aria-label={action.title}
                                key={index}
                                onClick={() => {
                                    void hardware.haptic();
                                    if ("link" in action) {
                                        if (
                                            action.link == null ||
                                            typeof action.link === "string"
                                        ) {
                                            throw new Error(
                                                "Only locator links supported",
                                            );
                                        } else {
                                            return router.transition(action.link);
                                        }
                                    } else {
                                        action.onClick?.();
                                    }
                                }}
                                className={ACTION_BAR_BUTTON_CLASS}
                            >
                                <div className="flex items-center gap-2">
                                    <SimpleIcon icon={action.icon} />
                                    {action.title}
                                </div>
                            </AsyncButton>
                        );
                    })}
            </ul>
        );
    }

    const twoRows = props.actions.length >= 6;
    return (
        <>
            {twoRows && (
                <ul className={ActionBar_class}>
                    {props.actions
                        .slice(0, 2)
                        .map((action, index) =>
                            action != null ? <Action key={index} {...action} /> : null,
                        )}
                </ul>
            )}
            <ul className={ActionBar_class}>
                {props.actions
                    .slice(twoRows ? 2 : 0)
                    .map((action, index) =>
                        action != null ? <Action key={index} {...action} /> : null,
                    )}
            </ul>
        </>
    );
};
